"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillData = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var hsRecord_1 = require("../../model/hsRecord");
var service_1 = require("../../../library/base/service");
var BillData = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(BillData, _super);
    function BillData() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '账单记录';
        _this.code = '105028';
        _this.desc = '账单记录';
        _this.requestParams = new hsRecord_1.BillDataRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return BillData;
}(service_1.BaseService));
exports.BillData = BillData;
//# sourceMappingURL=billData.js.map